var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-with-menu',{attrs:{"hideMenu":true}},[_c('bb-navbar',{attrs:{"login":_vm.login,"flavor":"public"}},[_c('bb-logo',{attrs:{"to":"/","logo":_vm.image}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }